module.exports = __webpack_public_path__ + "index/img/icon_youhui.400c1a2b.svg";